import { HttpContextToken } from '@angular/common/http';

/**
 * When set to `true` on a request's `HttpContext`, the
 * `happyApiHeadersInterceptor` will not inject the `store_api_key` query param
 * for that request. Used for tenant-level endpoints that must remain unscoped
 * to a specific store (e.g. `GET /cache/versions`).
 */
export const SKIP_STORE_API_KEY = new HttpContextToken<boolean>(() => false);
